module.exports = __webpack_public_path__ + "img/er9.6fd1fd2e.png";